import { render } from "./SmartToolsModal.vue?vue&type=template&id=20da05c8&scoped=true"
import script from "./SmartToolsModal.vue?vue&type=script&lang=js"
export * from "./SmartToolsModal.vue?vue&type=script&lang=js"

import "./SmartToolsModal.vue?vue&type=style&index=0&id=20da05c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20da05c8"]])

export default __exports__